import styled from 'styled-components';

export default styled.span`
  color: #fff !important;
  text-decoration: none;
  transition: 250ms ease;
  margin-left: ${props => props.first ? "0" : "1rem"};

  &:visited{
    color: #fff !important;
  }

  &:hover{
    color: #fff !important;
    text-decoration: underline;
  }

  @media(min-width: 992px){
    margin-left: ${props => props.first ? "0" : "2rem"};
    color: #fff !important;
    &:hover{
      color: #fff !important;
      text-decoration: none;
    }
  }
`;